import { render } from "./InputDate.vue?vue&type=template&id=37e8173e"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"
script.render = render

export default script